import { useContext } from "react";
import { MainContext, PlayMode } from "../App";
import { Radio } from "antd";
import { PauseOutlined } from "@ant-design/icons";

const PlayOptions = () => {
  const { appState: context, setAppState: setContext } =
    useContext(MainContext);

  const setSpeed = (speed: number) => {
    setContext({
      ...context,
      view: {
        ...context.view,
        playMode: speed > 0 ? PlayMode.PLAY : PlayMode.PAUSE,
        speed,
      },
    });
  };

  return (
    <div>
      <Radio.Group
        value={context.view.speed}
        onChange={(e) => setSpeed(e.target.value)}
      >
        <Radio.Button value={0}>
          <PauseOutlined />
        </Radio.Button>
        <Radio.Button value={1}>x1</Radio.Button>
        <Radio.Button value={2}>x2</Radio.Button>
        <Radio.Button value={3}>x3</Radio.Button>
        <Radio.Button value={5}>x5</Radio.Button>
        <Radio.Button value={20}>MAX</Radio.Button>
      </Radio.Group>
    </div>
  );
};

export default PlayOptions;
